import { GET_DASHBOARD_INFO, GET_ACTIVITY_FEED } from "src/redux/actions/dashboard";
import { GetDashboardInfoResponseTypes, ActivityFeedResponse } from "src/redux/actions/dashboard/types";
import { RESET_STATE } from "../actions/auth";

export const initialState: DashboardState = {
  isLoading: false,
  dashboardData: undefined,
  error: undefined,
  activityFeed: undefined,
  isLoadingActivityFeed: false
};

export interface DashboardState {
  isLoading: boolean;
  dashboardData: GetDashboardInfoResponseTypes | undefined;
  error: any;
  activityFeed: ActivityFeedResponse | undefined;
  isLoadingActivityFeed: boolean;
}

const dashboard = (state = initialState, action: IActionType<any>): DashboardState => {
  switch (action.type) {
    case GET_DASHBOARD_INFO.REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: undefined
      };
    }

    case GET_DASHBOARD_INFO.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        dashboardData: action.payload as GetDashboardInfoResponseTypes,
        error: undefined
      };
    }

    case GET_DASHBOARD_INFO.ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    }

    case GET_ACTIVITY_FEED.REQUEST: {
      return {
        ...state,
        isLoadingActivityFeed: true
      };
    }

    case GET_ACTIVITY_FEED.SUCCESS: {
      return {
        ...state,
        isLoadingActivityFeed: false,
        activityFeed: action.payload as ActivityFeedResponse
      };
    }

    case GET_ACTIVITY_FEED.ERROR: {
      return {
        ...state,
        isLoadingActivityFeed: false
      };
    }

    case RESET_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};

export default dashboard;
